import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigService } from '../config/config.service';
import { SesionService } from '../sesion/sesion.service';
import { SwUpdate } from '@angular/service-worker';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {
  controller: string = "version/";
  showNewVersionToast: boolean = false;

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private sesion: SesionService,
    private updates: SwUpdate,
  ) { }

  intervalMS = 300000; // 5 minutos

  initVersionCheckInBG(checkInterval = this.intervalMS): void {
    interval(checkInterval).subscribe(() => {
      this.checkVersion();
    });
  }

  checkVersion(): void {
    const isPwa = this.isPwaInstalled();
    if (isPwa) {
      this.checkForPwaUpdates();
    } else {
      this.http.get<any>(this.config.apiUrl + this.controller + "current-version", this.sesion.headers).subscribe({
        next: (res) => {
          if (!environment.version || !res) return;
          const currentVersion = environment.version;
          if (res.version !== currentVersion) {
            if (!this.showNewVersionToast) this.showNewVersionToast = true;
          } else if (this.showNewVersionToast) {
            this.showNewVersionToast = false;
          }
        },
        error: (error) => {
          console.error('Error al consultar nueva versión:', error);
        }
      });
    }
  }

  isPwaInstalled(): boolean {
    return window.matchMedia('(display-mode: standalone)').matches ||
      (window.navigator as any).standalone === true; // iOS Safari
  }

  checkForPwaUpdates(): void {
    if (this.updates.isEnabled) {
      this.updates.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_READY') {
          this.showNewVersionToast = true;
        }
      });
      this.updates.checkForUpdate();
    }
  }

  activatePwaUpdate(): void {
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}